import { Component } from "../component"

export class SectionStory extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      observed: "-observed",
    }
  }

  ui() {
    return {
      signature: ".section-story-signature-wrapper",
    }
  }

  created() {
    const { signature } = this.$ui
    const { observed } = this.dynamicClasses

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            entry.target.classList.add(observed)
          } else {
            // entry.target.classList.remove(observed)
          }
        })
      },
      {
        rootMargin: "-200px",
      }
    )

    const signatureObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0) {
            entry.target.classList.add(observed)
          } else {
            // entry.target.classList.remove(observed)
          }
        })
      },
      {
        rootMargin: "-100px",
      }
    )

    sectionObserver.observe(this.$el)
    if (signature) {
      signatureObserver.observe(signature)
    }
  }
}
